module.exports = __webpack_public_path__ + "static/media/integrated-thumbnail.6f636c60.svg";